import { useQuery, useQueryClient, useMutation } from 'react-query';
import { ptBrCommon } from '@/lib/pt-br/messages';
import { ICreditCard } from '@/types';
import { API_ENDPOINTS } from '@/framework/client/api-endpoints';
import client from '@/framework/client';
import { useModalAction } from '@/components/ui/modal/modal.context';
import { toast } from 'react-toastify';
import { useUser } from '@/framework/user';

export function useCards(params?: any, options?: any) {
  const { isAuthorized } = useUser();

  const { data, isLoading, error } = useQuery<ICreditCard[], Error>(
    [API_ENDPOINTS.CARDS, params],
    () => client.cards.all(params),
    {
      enabled: isAuthorized,
      ...options,
    },
  );

  const formattedCards =
    data?.map((card) => ({
      ...card,
      card_number: `**** **** **** ${card.end}`,
    })) ?? [];

  return {
    cards: formattedCards,
    isLoading,
    error,
  };
}

export const useDeleteCard = () => {
  const queryClient = useQueryClient();
const { closeModal } = useModalAction();

  const { mutate, isLoading, error } = useMutation(client.cards.remove, {
    onSuccess: () => {
      closeModal();
      toast.success(`${"Deletado com sucesso"}`);
    },
    // Always refetch after error or success:
    onSettled: () => {
      queryClient.invalidateQueries(API_ENDPOINTS.CARDS);
    },
  });

  return {
    deleteCard: mutate,
    isLoading,
    error,
  };
};

export function useAddCards(method_key?: any) {
const { closeModal } = useModalAction();
  const queryClient = useQueryClient();
  const { mutate, isLoading, error } = useMutation(
    client.cards.addPaymentMethod,
    {
      onSuccess: () => {
        closeModal();
        toast.success(`${"Cartão adicionado com sucesso"}`, {
          toastId: 'success',
        });
      },
      onError: (error: any) => {
        const apiMessage =
          error?.response?.data?.error?.message ||
          error?.response?.data?.message;
        toast.error(
          typeof apiMessage === 'string' && apiMessage.trim()
            ? apiMessage
            : ptBrCommon('error-something-wrong'),
          {
            toastId: 'error',
          },
        );
      },
      // Always refetch after error or success:
      onSettled: () => {
        queryClient.invalidateQueries(API_ENDPOINTS.CARDS);
      },
    },
  );

  return {
    addNewCard: mutate,
    isLoading,
    error,
  };
}

export function useDefaultPaymentMethod() {
const queryClient = useQueryClient();
  const { mutate, isLoading, error } = useMutation(
    client.cards.makeDefaultPaymentMethod,
    {
      onSuccess: () => {
        toast.success(`${"Cartão padrão definido com sucesso"}`);
      },
      // Always refetch after error or success:
      onSettled: () => {
        queryClient.invalidateQueries(API_ENDPOINTS.CARDS);
      },
    },
  );

  return {
    createDefaultPaymentMethod: mutate,
    isLoading,
    error,
  };
}
